import { z } from 'zod';

import { unifyCustomColumnOptionList } from '../utils/formatters.js';

export enum CustomColumnFormat {
  text = 'text',
  number = 'number',
  currency = 'currency',
  percentage = 'percentage',
  integer = 'integer',
}

export enum CustomColumnType {
  singleInput = 'single_input',
  select = 'select',
}

export const OptionItemSchema = z.object({
  label: z.string(),
  value: z.coerce.string(),
  isDisabled: z.boolean().prefault(false),
});
const RowItemSchema = z.object({ name: z.string(), label: z.string() });
const ColumnItemSchema = z.object({ name: z.string(), label: z.string() });
const CustomColumnItemSchema = ColumnItemSchema.extend({
  fieldFormat: z.enum(CustomColumnFormat),
  fieldType: z.enum(CustomColumnType),
  selectValues:
    // TODO: leave "z.array(OptionItemSchema)" only when ff.mdmColumnsForBuyingPlan.enabled && datintell/mdm-mvp
    z
      .array(z.string())
      .or(z.array(OptionItemSchema))
      .transform(unifyCustomColumnOptionList),
});
const OtherTechCostColumnItemSchema = ColumnItemSchema.extend({
  isOtherTechCostField: z.boolean(),
});
const BuilderTableViewColumnSchema = z.union([
  ColumnItemSchema.strict(),
  CustomColumnItemSchema.strict(),
  OtherTechCostColumnItemSchema.strict(),
]);

export const BuilderTableViewResponseSchema = z.object({
  id: z.number(),
  campaignCollection: z.number(),
  columnWidth: z.record(z.string(), z.number()),
  columns: z.array(BuilderTableViewColumnSchema),
  name: z.string(),
  rows: z.array(RowItemSchema),
});

export type BuilderTableViewResponse = z.infer<
  typeof BuilderTableViewResponseSchema
>;
export type BuilderTableViewColumn = z.infer<
  typeof BuilderTableViewColumnSchema
>;
export type CustomColumnItem = z.infer<typeof CustomColumnItemSchema>;
export type OptionItem = z.infer<typeof OptionItemSchema>;
